import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import { LayoutComponent } from './layout/layout.component';
import {WorkingObjectsRoutingModule} from './working-objects-routing.module';
import {LayoutModule} from '@layoutComponents/layout.module';
import {ObjectsModule} from './objects/objects.module';
import {TechnicalDeviceModule} from './technical-device/technical-device.module';
import {ConclusionModule} from './conclusion/conclusion.module';
import {ElementGroupModule} from './element-group/element-group.module';
import {ElementModule} from './element/element.module';
import {ConclusionJournalModule} from './conclusion-journal/conclusion-journal.module';

@NgModule({
    declarations: [
        LayoutComponent
    ],
    imports: [
        CommonModule,
        LayoutModule,
        WorkingObjectsRoutingModule,

        ObjectsModule,
        TechnicalDeviceModule,
        ConclusionModule,
        ElementModule,
        ElementGroupModule,
        ConclusionJournalModule,
    ],
    providers: [
    ]
})
export class WorkingObjectsModule {
}
